import LoadingWidget from './LoadingWidget';

export default LoadingWidget;
